<template>
  <v-layout row wrap>
    <v-flex xs12 class="text-center">
      <v-btn
        depressed
        rounded
        class="primary white--text my-0 px-4"
        @click="nextFn"
        :loading="loading"
        >Cargar más</v-btn
      >
    </v-flex>
    <v-flex xs12 class="text-center my-0">
      <v-icon color="primary">fas fa-chevron-down</v-icon>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    nextFn: {
      type: Function
    }
  }
}
</script>
